<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-button @click="digAdd" icon="el-icon-plus" style="float: right;margin-right: 10px;">添加</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'name'
        label= '名称'
        width= '160'>
      </el-table-column>
      <el-table-column
        prop= 'descr'
        label= '描述'>
      </el-table-column>
      <el-table-column
        prop= 'addr'
        label= '地址'>
      </el-table-column>
      <el-table-column
        prop= 'code'
        label= '信用编码'>
      </el-table-column>
      <el-table-column
        prop= 'fund'
        label= '注册资金'>
      </el-table-column>
      <el-table-column
        prop= 'legalRepresentative'
        label= '法定代表人'>
      </el-table-column>
      <el-table-column
        prop= 'phone'
        label= '联系电话'
        width= '120'>
      </el-table-column>
      <el-table-column
        prop= 'industry'
        label= '行业'
        width= '120'>
      </el-table-column>
      <el-table-column
        prop= 'registrationAuthority'
        label= '登记机关'
        width= '120'>
      </el-table-column>
      <el-table-column
        prop= 'type'
        label= '企业类型'
        width= '120'>
        <template slot-scope='scope'>
          <el-button type='primary' size='small' v-if="scope.row.type===1">国有企业</el-button>
          <el-button type='primary' size='small' v-if="scope.row.type===2">集体所有制</el-button>
          <el-button type='primary' size='small' v-if="scope.row.type===3">私营企业</el-button>
          <el-button type='primary' size='small' v-if="scope.row.type===4">股份制企业</el-button>
          <el-button type='primary' size='small' v-if="scope.row.type===5">有限合伙企业</el-button>
          <el-button type='primary' size='small' v-if="scope.row.type===6">联营企业</el-button>
          <el-button type='primary' size='small' v-if="scope.row.type===7">外商投资企业</el-button>
          <el-button type='primary' size='small' v-if="scope.row.type===8">个人独资企业</el-button>
          <el-button type='primary' size='small' v-if="scope.row.type===9">股份合作企业</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'status'
        label= '企业状态'
        width= '80'>
        <template slot-scope='scope'>
          <el-button type='success' size='small' v-if="scope.row.status===1">经营中</el-button>
          <el-button type='primary' size='small' v-if="scope.row.status===2">歇业中</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'labels'
        label= '企业标签'>
      </el-table-column>

      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '280'>
        <template slot-scope='scope'>
          <el-button @click='manegeUser(scope.row)' type='text' size='small' style="color: #209323">指定账户</el-button>
          <el-button @click='digEdit(scope.row)' type='text' size='small' style="color: #209323">编辑</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="描述" :label-width="formLabelWidth">
          <el-input v-model="form.descr" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="地址" :label-width="formLabelWidth">
          <el-input v-model="form.addr" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="企业标签" :label-width="formLabelWidth">
          <el-input v-model="form.labels" autocomplete="off"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="经度" :label-width="formLabelWidth">
              <el-input v-model="form.lng" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纬度" :label-width="formLabelWidth">
              <el-input v-model="form.lat" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="信用编码" :label-width="formLabelWidth">
              <el-input v-model="form.code" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="区域编码" :label-width="formLabelWidth">
              <el-input v-model="form.areaId" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="注册资金" :label-width="formLabelWidth">
              <el-input v-model="form.fund" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法定代表人" :label-width="formLabelWidth">
              <el-input v-model="form.legalRepresentative" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系电话" :label-width="formLabelWidth">
              <el-input v-model="form.phone" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="登记机关" :label-width="formLabelWidth">
              <el-input v-model="form.registrationAuthority" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="行业" :label-width="formLabelWidth">
              <el-select v-model="form.industry" clearable placeholder="请选择">
                <el-option
                  v-for="item in industry"
                  :key="item.val"
                  :label="item.val"
                  :value="item.val">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="企业类型" :label-width="formLabelWidth">
              <el-select v-model="form.type" clearable placeholder="请选择">
                <el-option
                  v-for="item in types"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="企业状态" :label-width="formLabelWidth">
              <el-radio-group v-model="form.status" size="medium">
                <el-radio-button label=1>经营中</el-radio-button>
                <el-radio-button label=2>歇业中</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm()" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="curRow.name + '  指定账户'" :visible.sync="dialogUserVisible">
      <el-form>
        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-checkbox-group v-model="choseUsers" size="medium">
            <el-checkbox-button v-for="user in users" :label="user.id" :key="user.id">{{user.nickname}}</el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogUserVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitUsersForm()" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
export default {
  data () {
    return {
      tableData: [],
      name: '',
      dialogFormVisible: false,
      dialogDepartmentVisible: false,
      dialogUserVisible: false,
      industry: [],
      curRow: {},
      form: {
        id: null,
        addTime: null,
        upTime: null,
        name: null,
        descr: null,
        addr: null,
        lng: null,
        lat: null,
        code: null,
        areaId: null,
        businessLicenseUrl: null,
        fund: null,
        legalRepresentative: null,
        phone: null,
        industry: null,
        registrationAuthority: null,
        type: null,
        status: null,
        labels: null
      },
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      types: [
        {id: 1, name: '国有企业'},
        {id: 2, name: '集体所有制'},
        {id: 3, name: '私营企业'},
        {id: 4, name: '股份制企业'},
        {id: 5, name: '有限合伙企业'},
        {id: 6, name: '联营企业'},
        {id: 7, name: '外商投资企业'},
        {id: 8, name: '个人独资企业'},
        {id: 9, name: '股份合作企业'}
      ],
      users: [],
      choseUsers: null
    }
  },
  created () {
    this.query()
    this.loadIndustry()
    this.loadUsersWithOutOrg()
  },
  methods: {
    manageDepartment (row) {
      this.curRow = {...row}
      this.dialogDepartmentVisible = true
    },
    del (row) {
      let that = this
      console.log('del')
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/organization/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      console.log('delClose')
      document.body.click()
    },
    query () {
      let that = this
      requestService.get(`/organization/listPage?current=${that.current}&pageSize=${that.pageSize}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    loadUsersWithOutOrg () {
      let that = this
      requestService.get('/user/system/manage/list/withoutOrg', {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.users = res.data.body
      })
    },
    loadIndustry () {
      let that = this
      requestService.get('/dict/listByKkey?kkey=industry', {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.industry = res.data.body
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    digEdit (row = {}) {
      this.form = {...row}
      this.dialogFormVisible = true
    },
    digAdd () {
      this.form = {}
      this.dialogFormVisible = true
    },
    manegeUser (row = {}) {
      this.choseUsers = []
      this.curRow = {...row}
      this.dialogUserVisible = true
    },
    submitForm () {
      let that = this
      that.dialogFormVisible = false
      console.log('add')
      let url = '/organization/add'
      if (that.form.id) {
        url = '/organization/edit'
      }
      requestService.post(url, that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
        that.query()
      })
    },
    submitUsersForm () {
      let that = this
      that.dialogUserVisible = false
      console.log(this.choseUsers)
      let userIds = ''
      for (let index in this.choseUsers) {
        if (index < this.choseUsers.length - 1) {
          userIds = userIds + this.choseUsers[index] + ','
        } else {
          userIds = userIds + this.choseUsers[index]
        }
      }
      requestService.post('userInfo/bindOrg', {organizationId: this.curRow.id, userIds: userIds}, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        this.$message({
          message: res.msg ? res.msg : '绑定成功',
          type: 'success'
        })
        that.loadUsersWithOutOrg()
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/manage-components/organization/Index.vue